import { AsyncIterableX } from './asynciterablex';

class EmptyAsyncIterable<TSource> extends AsyncIterableX<TSource> {
  async *[Symbol.asyncIterator](): AsyncIterator<TSource> {
    // tslint:disable-next-line:no-empty
  }
}

export function empty<TSource>(): AsyncIterableX<TSource> {
  return new EmptyAsyncIterable<TSource>();
}



// WEBPACK FOOTER //
// ./node_modules/ix/asynciterable/empty.ts